import axios from '../utils/axios';

export default function fetchAssessmentResponse(adminId, jobId, seekerId, params) {

    return (
        axios.get(`admin/${adminId}/jobs/${jobId}/applications/${seekerId}/assessmentResponse`, { params })
    )
}
